import React, { Component } from 'react';
import { FormGroup, Label, Input } from 'reactstrap';
import AppButton from './AppButton';
import StarRatingComponent from 'react-star-rating-component';
import './ratemydelivery.scss';
import { SpeechBubble } from './SpeechBubble'

export class RateMyDelivery extends Component {
    static displayName = RateMyDelivery.name;

    constructor(props) {
        super(props);
        const { match: { params } } = this.props;
        this.dragactive = false;
        this.currentX = 0;
        this.initialX = 0;
        this.xOffset = 0;
        this.state = {
            shipment: {
                connote: ""
            },
            questionnaire: {},
            response: {token: params.jobid, questionnaireCode: "HD", completedTime: (new Date()).toISOString(), answer: []},
            currentQ: {question: "How likely are you to recommend<br/>Fliway to a friend"},
            currentR: {qText: "", rating: 7, comment: ""},
            currentQIndex: 0,
            comment: "",
            busy: true,            
            lensstyle: {},
            params: params || {jobid: null},
            buttonActionText: null,
            buttonFooterText: null,
            buttonHeaderText: null,
            submitting: false
        };

        this.handleTouchStart = this.handleTouchStart.bind(this);
        this.handleTouchMove = this.handleTouchMove.bind(this);
        this.handleTouchEnd = this.handleTouchEnd.bind(this);        
        this.handleClick = this.handleClick.bind(this);  
        this.handleLoadOrResize = this.handleLoadOrResize.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeAnswer = this.handleChangeAnswer.bind(this);        
    }

    handleChangeAnswer = (e) => {
        let val = e.target.value;
        this.setState(prevState => ({currentR: {...prevState.currentR, comment: val}}));
    }

    handleClick = (e) => {
        //console.log('click/touch', e, e.clientX);
        this.currentX = 0; this.initialX = 0; this.xOffset = 0;
        this.handleTouchStart({clientX: 0});
        this.handleTouchMove({clientX: this.centerOffset + e.clientX, preventDefault: () => {}});
        this.handleTouchEnd();
    }

    handleLoadOrResize() {
        if(this.handleResize)
            clearTimeout(this.handleResize);
        this.handleResize = setTimeout( () => {
            //console.log('handleLoadOrResize');
            if(this.state.busy === true)
                return;
            if(!this.lensElement){
                this.lensElement = document.getElementById("lens");
                this.starContainer = document.getElementById("starContainer");            
                this.stars = document.getElementsByClassName("star");
            }
            //this.starContainer.style.width = "auto";
            //this.starContainer.style.width = "100%";
            this.lensRect = this.lensElement.getBoundingClientRect();
            this.minX = -this.lensRect.width/2.0 + this.stars[0].clientLeft + 10;
            this.maxX = this.minX + this.starContainer.clientWidth - 20;
            this.currentX = 0; this.initialX = 0; this.xOffset = 0;
            this.centerOffset = -this.starContainer.offsetLeft - this.lensElement.clientWidth / 2.0;
            var selStar = this.stars[this.state.currentR.rating - 1];
            var lensInitLeft = this.centerOffset + (selStar.offsetLeft + (selStar.clientWidth / 2.0)) ;
            //console.log(`Init minX=${this.minX}, maxX=${this.maxX}, currentX=${this.currentX}, lensInitLeft=${lensInitLeft}`);        
            this.handleTouchStart({clientX: 0});
            // correct alignmnts
            for(var i = 0; i < this.stars.length; i++) {
                var star = this.stars[i];
                var icon = star.firstChild;
                icon.style.left = null;
                icon.style.top = null;
                // now correct the icon horizontal alignment (Argh!)                
                var starRect = star.getBoundingClientRect();                
                var starIconRect = icon.getBoundingClientRect();           
                var hadj = `${((1.0*(starRect.left) + starRect.width/2.0) - (1.0*(starIconRect.left) + starIconRect.width/2.0))}px`;
                icon.style.left = hadj;                
                var vadj = `${((((1.0*(starRect.top) + starRect.height/2.0) - (1.0*(starIconRect.top) + starIconRect.height/2.0))) / Math.max(starRect.height,starIconRect.height) * 6)}vmin`;
                icon.style.top = vadj;
            }
            this.handleTouchMove({clientX: lensInitLeft, preventDefault: () => {}});
            this.handleTouchEnd();
            this.handleResize = null;
        }, 100);
    }

    handleTouchStart = (e) => {     
        if (e.type === "touchstart") {
            this.initialX = e.touches[0].clientX - this.xOffset;
          } else {
            this.initialX = e.clientX - this.xOffset;
          }
          this.dragactive = true;
    }

    handleTouchMove = (e) => {
        const maxScale = 1.7, minScale = 0.5;
        if(this.dragactive){      
                e.preventDefault();                
                if (e.type === "touchmove") {
                    this.currentX = e.touches[0].clientX - this.initialX;
                } else {
                    this.currentX = e.clientX - this.initialX;
                }
                //console.log(`touch move currentX=${this.currentX}`);
                this.currentX = Math.min(this.maxX, Math.max(this.minX,this.currentX));
                this.xOffset = this.currentX;
                this.setState({lensstyle: {transform: `translate3d(${this.currentX}px, 0, 0`}});                
                var width = this.starContainer.clientWidth;
                var lensLeft = this.xOffset;
                //console.log(`start stars (width=${width}, contLeft=${containerLeft}, currentX=${lensLeft})`);
                // Set zoom on the stars
                var selectedStar = { i: 0, scale: 0};
                for(var i = 0; i < this.stars.length; i++) {
                    var star = this.stars[i];
                    var center = this.centerOffset + star.offsetLeft + (star.clientWidth / 2.0);
                    var factor = Math.abs(2.5 * Math.log(Math.abs(0.2 * (lensLeft - center) / width)));
                    var scale = Math.min(Math.max(factor * 0.1, minScale), maxScale);
                    //console.log(`star ${i} (center=${center}, factor=${factor} scale=${scale})`);                                        
                    star.style.transform = `scale(${scale})`;
                    star.classList.remove("selected");
                    if(scale > selectedStar.scale)
                        selectedStar = { i: i, scale: scale };
                }
                this.stars[selectedStar.i].classList.add('selected');
        }            
    }

    handleTouchEnd = (e) => {
        // calculate the closest star then do a move to set it to that exactly
        var selChange = 10000;
        var xoffset = this.xOffset;
        //console.log(`xoffset=${xoffset}`);
        var selRating = 0;
        for(var i = 0; i < this.stars.length; i++) {
            var star = this.stars[i];
            var center = this.centerOffset + star.offsetLeft + (star.clientWidth / 2.0);
            //console.log(`star ${i} center=${center}, selChange=${selChange}`);
            if(Math.abs(center - xoffset) < Math.abs(selChange)){
                selChange = center - xoffset;
                selRating = i + 1;
            }
        }
        this.setState(prevState => ({currentR: {...prevState.currentR, rating: selRating}}));
        
        // Apply correction to move to exact star location  
        var e = {clientX: (this.initialX + xoffset + selChange - 2), preventDefault: () => {}};
        //console.log(`dummy touchmove`, e);
        this.handleTouchMove(e);

        this.initialX = this.currentX;
        this.dragactive = false;
    }

    async componentDidMount() {          
        window.addEventListener('load', this.handleLoadOrResize);
        window.addEventListener('resize', this.handleLoadOrResize);     
        const { match: { params } } = this.props;
        if(params.jobid == "testing") {
            let q = { questions: [{ question: "Test Q 1" }, { question: "Test Q 2"}]};            
            await this.setState({
                shipment: {
                    connote: "TESTING"
                },
                busy: false,
                questionnaire: q
            });
            console.log(this.state);
            this.updateToQuestion(1);
            this.handleLoadOrResize();
            return;
        }
        var questionnaire = (await (await window.fetch('api/questionnaire/' + params.jobid)));
        
        if(questionnaire.status == "409"){
            alert("Sorry you cannot currently rate this. Tap to refresh");
            return this.props.history.push(`../../o/${params.jobid}`);
        }
        else if(questionnaire.status == "205"){
            alert("Sorry you have already rated this. Tap to refresh");
            return this.props.history.push(`../../o/${params.jobid}`);
        }
        else if(!questionnaire.ok){
            alert("Error: " + questionnaire.statusText);
        }
        
        questionnaire = await questionnaire.json();
        console.log('questionnaire found', questionnaire);
        // set the questionaire and currentQ
        if (questionnaire.shipment){
            this.setState({questionnaire: questionnaire.questionnaire, shipment: questionnaire.shipment});
            var totalQs = this.state.questionnaire.questions.length;
            let pathname = this.props.location.pathname;
            this.updateToQuestion(1);
            this.props.history.push({
                pathname: pathname,
                search: `q=1&t=${totalQs}`
            });
            let firstQ = this.state.questionnaire.questions[0];
            let firstR = {qText: firstQ.question, rating: 7, comment: ""};
            this.setState({currentQ: firstQ, currentR: firstR});
        }
        else if (questionnaire.status === 404) {
            this.setState({
                shipment: { connote: "SHIPMENT NOT FOUND" }
            });
        }        
        this.setState({busy: false});
        if(document.readyState === 'complete')
            this.handleLoadOrResize();
    }
    componentDidUpdate(prevProps) {
        const query = new URLSearchParams(this.props.history.location.search);    
        //console.log('query', this.props.history.location.search, prevProps.history.location.search, query.get("q"));
        if(query.has("q") && query.get("q") !== "rated" && this.state.currentQIndex !== query.get("q")-1) {
            this.state.questionnaire.questions[this.state.currentQIndex] = this.state.currentQ;
            this.state.response.answer[this.state.currentQIndex] = this.state.currentR;
            let newI = query.get("q")-1;
            this.updateToQuestion(newI+1);
            let newQ = this.state.questionnaire.questions[newI];
            let newR = this.state.response.answer[newI] || {qText: newQ.question, rating: 7, comment: ""};
             this.setState({currentQIndex: newI, currentQ: newQ, currentR: newR});
            this.handleLoadOrResize();
        }
    }

    updateToQuestion(nextQ) {
        let totalQs = this.state.questionnaire.questions.length;
        if(nextQ < totalQs) {
            this.setState({buttonHeaderText: <span style={{textAlign: 'right'}}>
                    {`(Question ${nextQ} of ${totalQs})`}</span>,
                buttonActionText: "Next", buttonFooterText: ""});
        }
        else{
            this.setState({buttonHeaderText: "", buttonActionText: "Submit Rating", buttonFooterText: "Thank you for your feedback"});
        }
    }
        
    async handleSubmit() {
        this.state.questionnaire.questions[this.state.currentQIndex] = this.state.currentQ;
        this.state.response.answer[this.state.currentQIndex] = this.state.currentR;
        var nextQ = this.state.currentQIndex+1;
        let totalQs = this.state.questionnaire.questions.length;
        this.updateToQuestion(nextQ+1);
        //console.log(`currentQIndex=${this.state.currentQIndex}, nextQ=${nextQ}, totalQs=${totalQs}`);
        let pathname = this.props.location.pathname;
        if(nextQ < totalQs){
            let newQ = this.state.questionnaire.questions[nextQ];
            let newR = this.state.response.answer[nextQ] || {qText: newQ.question, rating: 7, comment: ""};
            this.setState({currentQIndex: nextQ, currentQ: newQ, currentR: newR});
            this.props.history.push({
                pathname: pathname,
                search: `q=${nextQ+1}&t=${totalQs}`
            });
            this.handleLoadOrResize();
        }
        else {
            if (this.state.submitting) {
                return;
            }
            this.state.response.completedTime = (new Date()).toISOString();
            this.setState({ submitting: true });
            const result = await this.postData('api/questionnaire/' + this.state.params.jobid, this.state.response);
            if(!result.ok){
                alert("Error: " + result.statusText);
                this.setTate({ submitting: false });
            }
            return this.props.history.push(`../../o/${this.state.params.jobid}`);
        }
    }

    postData(url = '', data = {}) {
        return fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
            redirect: 'follow',
            referrer: 'no-referrer',
            body: JSON.stringify(data),
        })
        .then(response => {
            if(!response.ok) {
                if(response.status == "409"){
                    alert("Sorry this is out of date; Tap to refresh.");
                    return this.loadOffer();
                }
                else{
                    alert("Error: " + response.statusText);
                }
            }
            return response;
        });
    }

    render() {
        return (
            <div>
                <div className="header">RATE MY DELIVERY</div>
                {this.state.busy === true && <div>Loading...</div>}
                {this.state.rated === true && <div>Thank you for your rating...</div>}
                {(this.state.busy !== true && this.state.rated !== true ) &&
                <div className="view-body rate-my-driver" onTouchMove={this.handleTouchMove} onMouseMove={this.handleTouchMove}
                    onTouchEnd={this.handleTouchEnd} onMouseUp={this.handleTouchEnd}>
                    <FormGroup>
                    <div className="edit-icon-right">
                        <div>
                            <label>Consignment Number</label>
                            <div className="fakeinput">
                                {this.state.shipment.connote}
                            </div>
                        </div>
                        <div><i className="icon-x-app-icon connote"></i></div>
                    </div>
                    </FormGroup>
                    <FormGroup>
                        <SpeechBubble className="rate-bubble" content={<span dangerouslySetInnerHTML={{__html: this.state.currentQ.question}}></span>} />
                        <div className="star-cont-parent">
                            <div className="star-container" id="starContainer" onClick={this.handleClick}>
                                <div className="lens" id="lens" style={this.state.lensstyle} onTouchStart={this.handleTouchStart} 
                                    onMouseDown={this.handleTouchStart}></div>
                                <div className="star"><i className="icon-star"></i><span>1</span></div>
                                <div className="star"><i className="icon-star"></i><span>2</span></div>
                                <div className="star"><i className="icon-star"></i><span>3</span></div>
                                <div className="star"><i className="icon-star"></i><span>4</span></div>
                                <div className="star"><i className="icon-star"></i><span>5</span></div>
                                <div className="star"><i className="icon-star"></i><span>6</span></div>
                                <div className="star"><i className="icon-star"></i><span>7</span></div>
                                <div className="star"><i className="icon-star"></i><span>8</span></div>
                                <div className="star"><i className="icon-star"></i><span>9</span></div>
                                <div className="star"><i className="icon-star"></i><span>10</span></div>
                            </div>
                        </div>
                        <div className="rating-legend">
                            <span>1 = Not at all likely</span>
                            <span>10 = Extremely likely</span>
                        </div>
                    </FormGroup>
                    <FormGroup className="rating">
                        <Label for="comment">Rating</Label>
                        <StarRatingComponent 
                        name="deliveryratingsmall" 
                        className="small"
                        starCount={10} starColor="#002b5c" emptyStarColor="#1396d3"
                        value={this.state.currentR.rating}
                        renderStarIcon={(index, value) => {
                            return (
                                <i className="icon-star"></i>
                            );}}
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="comment">Please help us understand your score</Label>
                        <Input type="textarea" name="comment" id="comment" value={this.state.currentR.comment} onChange={this.handleChangeAnswer} />
                    </FormGroup>
                    <AppButton onClick={this.handleSubmit} iconName="icon-button-tick" highlight header={this.state.buttonHeaderText}
                        actionText={this.state.buttonActionText} footer={this.state.buttonFooterText} enabled={!this.state.submitting}/>
                </div>}
            </div>
        );
    }
}
